import React from 'react'
import { Box } from '@mui/material/'
import { FirstDepthCatalogCategoriesFragment } from '@services/cloud/client'
import CatalogTabs from '@containers/Catalogs/CatalogTabs'
import { CategoryList } from '../CategoryList'

type Props = {
  firstDepthCategories: FirstDepthCatalogCategoriesFragment[]
}

export const AllFirstDepthCategory = (props: Props) => (
  <Box minHeight="80vh">
    <CatalogTabs />
    <Box mt={5}>
      <CategoryList categories={props?.firstDepthCategories} />
    </Box>
  </Box>
)
